import { useState, useEffect } from 'react';
import { getUnixTime, startOfDay, endOfDay } from 'date-fns';

export const useSessionsSearchFilters = (event, activeDay, selectedTracks, isGlobal) => {
    const [filters, setFilters] = useState('');

    useEffect(() => {
        if (!event?.event_code) return;

        const filterArray = [`event.event_code:${event.event_code}`];

        if (!isGlobal) {
            if (activeDay) {
                filterArray.push(`session_start_time >= ${getUnixTime(startOfDay(activeDay))}`);
                filterArray.push(`session_start_time <= ${getUnixTime(endOfDay(activeDay))}`);
            }

            if (selectedTracks?.length > 0) {
                const trackFilters = selectedTracks.map(t => `session_tracks:"${t}"`).join(' OR ');
                filterArray.push(`(${trackFilters})`);
            }
        }

        setFilters(filterArray.join(' AND '));
    }, [event?.event_code, activeDay, selectedTracks, isGlobal]);

    return filters;
};
